import { AbsoluteCenter, EmptyState, List, VStack } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { HiColorSwatch } from 'react-icons/hi';

export const ResultNotFound = () => {
  const { t } = useTranslation();
  return (
    <AbsoluteCenter>
      <EmptyState.Root>
        <EmptyState.Content>
          <EmptyState.Indicator>
            <HiColorSwatch />
          </EmptyState.Indicator>
          <VStack textAlign="center">
            <EmptyState.Title>{t('messages.errors.noResult.title')}</EmptyState.Title>
            <EmptyState.Description>{t('messages.hints.ajustingSearch')}</EmptyState.Description>
          </VStack>
          <List.Root variant="marker">
            <List.Item>{t('messages.hints.removingFilters')}</List.Item>
            <List.Item>{t('messages.hints.useDifferentKeywords')}</List.Item>
          </List.Root>
        </EmptyState.Content>
      </EmptyState.Root>
    </AbsoluteCenter>
  );
};
